import { buildHeaders } from 'src/utils/apiUtils';
import type { DynamicChartConfig } from './ChartRegistry';

const BASE = process.env.REACT_APP_API_URL ?? '';

export interface SavedChart {
  id: string;
  label: string;
  config: DynamicChartConfig;
  isShared: boolean;
  isOwner: boolean;
  createdAt: string;
}

export async function loadDashboardChartsApi(): Promise<SavedChart[]> {
  try {
    const headers = await buildHeaders(BASE);
    const res = await fetch(`${BASE}/dashboard-charts`, { headers, credentials: 'include' });
    if (!res.ok) return [];
    const json = await res.json();
    return Array.isArray(json?.data) ? json.data : [];
  } catch {
    return [];
  }
}

export async function saveDashboardChartApi(payload: {
  label: string;
  config: DynamicChartConfig;
  isShared: boolean;
}): Promise<SavedChart | null> {
  try {
    const headers = await buildHeaders(BASE);
    const res = await fetch(`${BASE}/dashboard-charts`, {
      method: 'POST',
      headers: { ...headers, 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(payload),
    });
    if (!res.ok) return null;
    const json = await res.json();
    return json?.data ?? null;
  } catch {
    return null;
  }
}

export async function deleteDashboardChartApi(id: string): Promise<boolean> {
  try {
    const headers = await buildHeaders(BASE);
    const res = await fetch(`${BASE}/dashboard-charts/${id}`, {
      method: 'DELETE',
      headers,
      credentials: 'include',
    });
    return res.ok;
  } catch {
    return false;
  }
}
